import { useEffect, useRef } from 'react';
import { MarkdownOutput } from 'react-rainbow-components';
import { StyledMarkdownOutput } from './styled';

interface BodyProps {
    body: string;
}

const Body = ({ body }: BodyProps) => {
    const markdownRef = useRef<HTMLDivElement>(null);

    // Make all links open in new tab
    useEffect(() => {
        if (markdownRef.current) {
            const links = markdownRef.current.querySelectorAll('a');
            links.forEach((link) => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });
        }
    }, [body]);

    return (
        <StyledMarkdownOutput ref={markdownRef}>
            <MarkdownOutput value={body} />
        </StyledMarkdownOutput>
    );
};

export default Body;
